import { useState } from "react";
import { DCorteStyleStyle, DCorteButonStyleStyle } from "./DCorteStyle";
import { Button, Grid } from "@material-ui/core";
import HeaderModal from "../../../../global/headerModal";
import ModalBase from "./../../../../global/ModalBase";
import { useDetalleCorte } from "../../../../hooks/useDetalleCorte";
import TMovimientos from "./TMovimientos";
const DBCorte = ({ disabled = false, idCorte = 0 }) => {
    const [isOpen, setIsOpen] = useState(false);
    const handleOpen = () =>{
        setIsOpen(!isOpen)
    }
    const classButton = DCorteButonStyleStyle();
    return (
        <div className={classButton.flexEnd}>
            <Button variant="outlined" color="primary" onClick={handleOpen} disabled={disabled}>
                Detalle
            </Button>
            <DCorte open={isOpen} setOpen={handleOpen} idCorte={idCorte}/>
        </div>
    );
};

const DCorte =  ({ open = true, setOpen = () => { }, idCorte = 0 }) => {
    const classes = DCorteStyleStyle();
    const [movimientos] = useDetalleCorte({idCorte})
    const handleClose = () => {
        setOpen();
    };
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal handleClose={handleClose} titulo={`Corte de Caja`} />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <TMovimientos rows={movimientos} />
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={handleClose}
                        className={classes.modalBoton} 
                    >
                        {"Aceptar"}
                    </Button>
                </Grid>
            </Grid>
        </ModalBase>
    );
}
export default DBCorte